module.exports = __webpack_public_path__ + "img/pc-banner.cb20d304.png";